// Swaps the small variant thumbnail next to each quantity-break dropdown to the chosen variant's image.
document.addEventListener('change', (event) => {
  const select = event.target.closest('.quantity-break__variant-select');
  if (!select) return;

  const container = select.closest('quantity-breaks');
  const item = select.closest('.quantity-break__selector-item');
  const map = container?.querySelector('.quantity-break__variant-images');
  const thumb = item?.querySelector('.quantity-break__thumb');
  if (!map || !thumb) return;

  let images;
  try {
    images = JSON.parse(map.textContent);
  } catch (e) {
    return;
  }

  const title = Array.from(item.querySelectorAll('.quantity-break__variant-select'))
    .map((el) => el.value)
    .join(' / ');
  if (images[title]) thumb.src = images[title];
});
